import ListPermintaanTransferPrelim from './ListPermintaanTransferPrelim';

export default ListPermintaanTransferPrelim;
